/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetQuestionAndAnswerDtoAnswer } from './GetQuestionAndAnswerDtoAnswer';
import {
    GetQuestionAndAnswerDtoAnswerFromJSON,
    GetQuestionAndAnswerDtoAnswerFromJSONTyped,
    GetQuestionAndAnswerDtoAnswerToJSON,
} from './GetQuestionAndAnswerDtoAnswer';
import type { GetQuestionDto } from './GetQuestionDto';
import {
    GetQuestionDtoFromJSON,
    GetQuestionDtoFromJSONTyped,
    GetQuestionDtoToJSON,
} from './GetQuestionDto';

/**
 * 
 * @export
 * @interface GetQuestionAndAnswerDto
 */
export interface GetQuestionAndAnswerDto {
    /**
     * 
     * @type {GetQuestionDto}
     * @memberof GetQuestionAndAnswerDto
     */
    question: GetQuestionDto;
    /**
     * 
     * @type {GetQuestionAndAnswerDtoAnswer}
     * @memberof GetQuestionAndAnswerDto
     */
    answer?: GetQuestionAndAnswerDtoAnswer | null;
}

/**
 * Check if a given object implements the GetQuestionAndAnswerDto interface.
 */
export function instanceOfGetQuestionAndAnswerDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function GetQuestionAndAnswerDtoFromJSON(json: any): GetQuestionAndAnswerDto {
    return GetQuestionAndAnswerDtoFromJSONTyped(json, false);
}

export function GetQuestionAndAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestionAndAnswerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'question': GetQuestionDtoFromJSON(json['question']),
        'answer': !exists(json, 'answer') ? undefined : GetQuestionAndAnswerDtoAnswerFromJSON(json['answer']),
    };
}

export function GetQuestionAndAnswerDtoToJSON(value?: GetQuestionAndAnswerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'question': GetQuestionDtoToJSON(value.question),
        'answer': GetQuestionAndAnswerDtoAnswerToJSON(value.answer),
    };
}

